(function(angular) {
    'use strict';
    angular.module('wtUi.wtBreadcrumb').component('wtBreadcrumb', {
        template: ['$templateCache', function($templateCache) {
            return $templateCache.get('src/breadcrumb/breadcrumb.tpl.html');
        }],
        controller: 'WtBreadcrumbController as wtBreadcrumb',
        bindings: {
            account: '<',
            head: '<?',
            tail: '<?'
        },
        transclude: {
            slot1: '?slot1',
            slot2: '?slot2'
        }
    });
})(window.angular);
